const TEXT = {
    // Dashboard title and navigation
    Dashboard: {
        "en": "Dashboard",
        "ar": "لوحة المعلومات"
    },
    BackToGroups: {
        "en": "Back to Groups",
        "ar": "العودة إلى المجموعات"
    },
    
    // Loading states
    Loading: {
        "en": "Loading...",
        "ar": "جاري التحميل..."
    },
    SyncingData: {
        "en": "Syncing data...",
        "ar": "جاري مزامنة البيانات..."
    },
    
    // Group overview
    GroupOverview: {
        "en": "Group Overview",
        "ar": "نظرة عامة على المجموعة"
    },
    TotalRecords: {
        "en": "Total Records",
        "ar": "إجمالي السجلات"
    },
    TotalUsers: {
        "en": "Total Users",
        "ar": "إجمالي المستخدمين"
    },
    ChildGroups: {
        "en": "Child Groups",
        "ar": "المجموعات الفرعية"
    },
    NoChildGroups: {
        "en": "No child groups",
        "ar": "لا توجد مجموعات فرعية"
    },
    
    // Charts
    RecordsDistribution: {
        "en": "Records Distribution",
        "ar": "توزيع السجلات"
    },
    DailyGrowth: {
        "en": "Daily Growth (Last 30 Days)",
        "ar": "النمو اليومي (آخر 30 يوم)"
    },
    SelectColumn: {
        "en": "Select Column",
        "ar": "اختر العمود"
    },
    ChartType: {
        "en": "Chart Type",
        "ar": "نوع الرسم البياني"
    },
    PieChart: {
        "en": "Pie Chart",
        "ar": "رسم بياني دائري"
    },
    BarChart: {
        "en": "Bar Chart",
        "ar": "رسم بياني شريطي"
    },
    
    // Statistics
    Records: {
        "en": "Records",
        "ar": "سجلات"
    },
    NewRecords: {
        "en": "New Records",
        "ar": "سجلات جديدة"
    },
    average_daily: {
        "en": "Avrage Daily",
        "ar": "متوسط يومي"
    },
    Average: {
        "en": "Average",
        "ar": "متوسط"
    },
    Peak: {
        "en": "Peak",
        "ar": "ذروة"
    },
    Total: {
        "en": "Total",
        "ar": "الإجمالي"
    },
    PerDay: {
        "en": "per day",
        "ar": "في اليوم"
    },
    Last7Days: {
        "en": "Last 7 Days",
        "ar": "آخر 7 أيام"
    },
    Last30Days: {
        "en": "Last 30 Days",
        "ar": "آخر 30 يوم"
    },
    
    // Loading and errors
    Loading: {
        "en": "Loading...",
        "ar": "جاري التحميل..."
    },
    Calculating: {
        "en": "Calculating...",
        "ar": "جاري الحساب..."
    },
    Error: {
        "en": "Error",
        "ar": "خطأ"
    },
    ErrorLoadingData: {
        "en": "Error loading dashboard data",
        "ar": "خطأ في تحميل بيانات لوحة المعلومات"
    },
    NoData: {
        "en": "No data available",
        "ar": "لا توجد بيانات متاحة"
    },
    NoRecords: {
        "en": "No records found",
        "ar": "لم يتم العثور على سجلات"
    },
    Retry: {
        "en": "Retry",
        "ar": "إعادة المحاولة"
    },
    
    // Cache and version
    CacheStatus: {
        "en": "Cache Status",
        "ar": "حالة ذاكرة التخزين المؤقت"
    },
    Cached: {
        "en": "Cached",
        "ar": "مخزن مؤقتًا"
    },
    Fresh: {
        "en": "Fresh",
        "ar": "جديد"
    },
    Stale: {
        "en": "Stale",
        "ar": "قديم"
    },
    Version: {
        "en": "Version",
        "ar": "إصدار"
    },
    LastUpdated: {
        "en": "Last Updated",
        "ar": "آخر تحديث"
    },
    RefreshData: {
        "en": "Refresh Data",
        "ar": "تحديث البيانات"
    },
    
    // Actions
    ViewDetails: {
        "en": "View Details",
        "ar": "عرض التفاصيل"
    },
    Expand: {
        "en": "Expand",
        "ar": "توسيع"
    },
    Collapse: {
        "en": "Collapse",
        "ar": "طي"
    },
    Export: {
        "en": "Export",
        "ar": "تصدير"
    },
    
    // Misc
    NoColumnsAvailable: {
        "en": "No columns available",
        "ar": "لا توجد أعمدة متاحة"
    },
    DataFreshness: {
        "en": "Data Freshness",
        "ar": "حداثة البيانات"
    },
    CalculatingData: {
        "en": "Calculating data from local database...",
        "ar": "جاري حساب البيانات من قاعدة البيانات المحلية..."
    },
    Percentage: {
        "en": "Percentage",
        "ar": "نسبة مئوية"
    },
    Count: {
        "en": "Count",
        "ar": "عدد"
    },
    Date: {
        "en": "Date",
        "ar": "تاريخ"
    }
};

export default TEXT;
